"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var S = _interopRequireWildcard(require("./Accordion.style"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Accordion = function Accordion(_ref) {
  var children = _ref.children,
      onChange = _ref.onChange,
      open = _ref.open,
      props = _objectWithoutProperties(_ref, ["children", "onChange", "open"]);

  var _useState = (0, _react.useState)(open ? 0 : -1),
      _useState2 = _slicedToArray(_useState, 2),
      openItem = _useState2[0],
      setOpenItem = _useState2[1];

  (0, _react.useEffect)(function () {
    return onChange && onChange(openItem);
  }, [openItem, onChange]);
  return /*#__PURE__*/_react["default"].createElement("div", props, _react.Children.map(children, function (child, currentItem) {
    return /*#__PURE__*/(0, _react.cloneElement)(child, {
      open: openItem === currentItem,
      setOpenItem: setOpenItem,
      currentItem: currentItem
    });
  }));
};

Accordion.propTypes = {
  children: _propTypes["default"].node.isRequired,

  /**
   * Callback fired when the expand/collapse state is changed.
   */
  onChange: _propTypes["default"].func,
  open: _propTypes["default"].bool
};

var Item = function Item(_ref2) {
  var children = _ref2.children,
      title = _ref2.title,
      icon = _ref2.icon,
      currentItem = _ref2.currentItem,
      open = _ref2.open,
      setOpenItem = _ref2.setOpenItem,
      props = _objectWithoutProperties(_ref2, ["children", "title", "icon", "currentItem", "open", "setOpenItem"]);

  var _useState3 = (0, _react.useState)('0px'),
      _useState4 = _slicedToArray(_useState3, 2),
      bodyHeight = _useState4[0],
      setBodyHeight = _useState4[1];

  var bodyRef = (0, _react.useRef)();

  var handleToggle = function handleToggle() {
    return open ? setOpenItem(-1) : setOpenItem(currentItem);
  };

  var handleOpen = function handleOpen() {
    setTimeout(function () {
      return setBodyHeight("".concat(bodyRef.current.scrollHeight, "px"));
    });
    setTimeout(function () {
      return setBodyHeight('auto');
    }, 400);
  };

  var handleClose = function handleClose() {
    setBodyHeight("".concat(bodyRef.current.scrollHeight, "px"));
    setTimeout(function () {
      return setBodyHeight('0px');
    });
  };

  (0, _react.useEffect)(function () {
    open ? handleOpen() : handleClose();
  }, [open]);
  return /*#__PURE__*/_react["default"].createElement(S.Item, _extends({
    open: open
  }, props), /*#__PURE__*/_react["default"].createElement(S.Head, {
    open: open,
    onClick: handleToggle
  }, icon && /*#__PURE__*/_react["default"].createElement(S.Icon, {
    as: icon
  }), /*#__PURE__*/_react["default"].createElement(S.Title, null, title), /*#__PURE__*/_react["default"].createElement(S.OpenIcon, {
    open: open
  })), /*#__PURE__*/_react["default"].createElement(S.Body, {
    ref: bodyRef,
    height: bodyHeight
  }, children));
};

Item.propTypes = {
  children: _propTypes["default"].node.isRequired,
  title: _propTypes["default"].string.isRequired,

  /**
   * The icon element.
   */
  icon: _propTypes["default"].func,

  /**
   * @ignore
   */
  currentItem: _propTypes["default"].number,

  /**
   * @ignore
   */
  open: _propTypes["default"].bool,

  /**
   * @ignore
   */
  setOpenItem: _propTypes["default"].func
};
Accordion.Item = Item;
var _default = Accordion;
exports["default"] = _default;